// apps/web/src/features/crm/leads/card/LeadCardSideActions.tsx
//
// Header side actions for the card (#2247 FR-2): postpone / refuse / non-target.
// Each is a LEAD-phase stage target routed through the reused
// `useTransitionLeadStage` (postpone → `postponed`, refuse → `refusal`,
// non-target → `not_suitable`). Rendered only for a manageable, non-terminal
// lead — a terminal projection offers back-to-work on the pills instead, so no
// dead control appears (BR-6).
import { useTranslation } from 'react-i18next';
import type { LeadStageCode } from '@magimp/shared';
import { Button } from '../../../../ui/index.js';

export interface LeadCardSideActionsProps {
  busy: boolean;
  onTransition: (toStage: LeadStageCode) => void;
}

export function LeadCardSideActions({ busy, onTransition }: LeadCardSideActionsProps) {
  const { t } = useTranslation(['leads']);
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }} data-testid="lead-card-side-actions">
      <Button
        kind="ghost"
        size="sm"
        icon="clock"
        disabled={busy}
        onClick={() => onTransition('postponed')}
        data-testid="lead-card-postpone"
      >
        {t('leads:card.actions.postpone')}
      </Button>
      <Button
        kind="ghost"
        size="sm"
        disabled={busy}
        onClick={() => onTransition('not_suitable')}
        data-testid="lead-card-non-target"
      >
        {t('leads:card.actions.nonTarget')}
      </Button>
      <Button
        kind="danger"
        size="sm"
        disabled={busy}
        onClick={() => onTransition('refusal')}
        data-testid="lead-card-refuse"
      >
        {t('leads:card.actions.refuse')}
      </Button>
    </div>
  );
}
